<script>
  import { onMount } from 'svelte'
  import { location, push } from 'svelte-spa-router'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import PageHeader from '../../components/PageHeader.svelte'
  import Button from '../../components/Button.svelte'
  import Modal from '../../components/Modal.svelte'
  import { modalStore, userStore, snackBarStore, peopleStore, tenantStore } from '../../state/store'
  import { isUserAdmin, showInfo, multiFilter } from './../../helpers/utils.js'
  import Icon from '../../components/Icon.svelte'
  import Spinner from '../../components/Spinner.svelte'
  import PersonAdd from './People.add.svelte'
  import { getPeopleData, getLocationData, getClientData } from '../../state/actions'
  import { request } from '../../helpers/api'
  import { t, language } from '../../i18n/i18n'

  let promise

  onMount(() => {
    promise = Promise.all([getLocationData(), getPeopleData(), getClientData()])
  })

  let searchTerm = ''
  $: people = multiFilter($peopleStore, ['name', 'email'], searchTerm)

  const showAddPerson = () => modalStore.toggle('add_person')

  const removeInvite = async (e) => {
    if (isUserAdmin($userStore)) {
      try {
        const response = await request({
          url: `/api/invite`,
          method: 'DELETE',
          body: JSON.stringify({
            email: e.target.dataset.email.toString(),
            tenant: $userStore.tenant_id
          })
        })
        tenantStore.set(response)
        snackBarStore.set({ message: `${$t.invitee_removed}: ${e.target.dataset.email}`, type: 'success', selfDestruct: true })
      } catch (error) {
        snackBarStore.set({ message: $t.something_wrong, type: 'error' })
      }
    }
  }
</script>

<style>
  .me-card {
    position: relative;
  }

  .me-label {
    position: absolute;
    color: var(--white);
    top: -1.6rem;
    left: -1.8rem;
    background: var(--blue);
    border-radius: 50%;
    padding: 1rem; 
    font-size: 1.2rem;
  }

  @media (min-width: 767px) {
    .remove {
      text-align: end;
    }
  }

  .remove button {
    border-radius: 50%;
    border: 0;
    padding: 0.5rem 0.8rem 0.9rem;
    color: white;
    background: var(--red);
  }
  
</style>

<ViewContainer>
  <PageHeader>
    <h1>{$t.people}</h1>
    <Button on:click={showAddPerson}>{$t.add_person}</Button>
  </PageHeader>

  {#await promise}
    <Spinner />
  {:then}
    <section class="g-search">
      <span class="icon"><Icon name='search' /></span>
      <input type="text" id="search" bind:value={searchTerm} placeholder={$t.search}>
    </section>
    <article class="g-card-list-wrapper">
      {#each people as data, index}
      <ul class='g-card-list' class:me-card={data.email === $userStore.email} on:click={() => push(`/people/${data._id}`)}>
        {#if data.email === $userStore.email }
          <li class="me-label">{$t.me}</li>
        {/if}
        {#each Object.entries(data) as [key, val]}
          {#if 
            key !== '_id' &&
            key !== 'tenant_id' &&
            showInfo({key, isAdmin: isUserAdmin($userStore)})
          }
            <li>
              <p>{$t[key]}</p>
              <p>{val}</p>
            </li>
          {/if}
        {/each}
      </ul>
      {/each}
    </article>
    {#if $tenantStore.invited_users && $tenantStore.invited_users.length > 0}
      <h2>{$t.invited_users}</h2>
      <article class="g-card-list-wrapper">
        {#each $tenantStore.invited_users as user}
        <div class='g-card-list'>
          <div>
            <p>{$t.email}</p>
            <p>{user.email}</p>
          </div>
          <div>
            <p>{$t.invited_role}</p>
            <p> {user.role === 'admin' ? 'Admin': 'Worker'} </p>
          </div>
          <div class="remove">
            <button type="button" on:click="{removeInvite}" data-email="{user.email}"><Icon name='close' /></button>
          </div>
        </div>
        {/each}
      </article>
    {/if}
  {/await}

  <Modal name='add_person'>
    <h1 slot='header'>{$t.add_person}</h1>
    <PersonAdd />
  </Modal>

</ViewContainer>
